/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckUserBasic {
  readonly id: string;
  readonly first_name: string;
  readonly last_name: string;
  readonly email: string;
}
